/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Station_Fleet_EmptyInputs */

const vi_station_fleet_empty = /** @type {(inputs: Station_Fleet_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không có phương tiện di chuyển`)
};

/**

* @param {Station_Fleet_EmptyInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_fleet_empty = /** @type {((inputs?: Station_Fleet_EmptyInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Fleet_EmptyInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_fleet_empty(inputs)
});